
export const ETA_MODEL ={
    estimatedTimeOfArrivalDate: null,
    userId: null,
    vehicleId: null,
    toSetUser: function (e){
        return {
            id: e.supplierEmployeeUserId,
            name: e.supplierEmployeeName,
            lastName: e.supplierEmployeeLastName,
            secondLastName: e.supplierEmployeeSecondLastName,
            email: e.supplierEmployeeEmail,
            phone: e.supplierEmployeePhoneNumber,
            userId:  e.supplierEmployeeUserId,
        }
    },
    toSetVehicle: function (e){
        return {
            id: e.supplierVehicleVehicleId,
            brand: e.supplierVehicleBrand,
            subBrand: e.supplierVehicleSubBrand,
            model:  e.supplierVehicleModel,
            plate: e.supplierVehiclePlate,
            color: e.supplierVehicleColor
        }
    }
}


export const DELIVERY_ORDER_MODEL = {
    id: null,
    actualDeliveryDate: null,
    receivers: [],
    deliveryNote: null,
    evidence: [],
    toRegister: function ({ files, receivers }) {
        const formData = new FormData();
        formData.append('id', this.id);
        formData.append('actualDeliveryDate', new Date(this.actualDeliveryDate).getTime());
        receivers.forEach((e, index) => {
            formData.append(`receivers[${index}].userId`, e);
        });
        formData.append('deliveryNote', this.deliveryNote);
        if (Array.isArray(files)) {
            files.forEach((e, index) => {
                formData.append(`evidence[${index}].fileUploadDto.files`, e.fileSelected);
                formData.append(`evidence[${index}].fileUploadDto.userFileNames`, e.fileSelected.name);
            });
        } else if (files) {
            formData.append('evidence[0].fileUploadDto.files', files.fileSelected);
            formData.append('evidence[0].fileUploadDto.userFileNames', files.fileSelected.name);
        }
        return formData;
    },
    clear: function () {
        return {
            ...this,
            actualDeliveryDate: null,
            receivers: [],
            deliveryNote: null,
            evidence: [],
        }
    },
    isValid: function ({ photoPicker }) {
        let files = photoPicker.listFiles;

        return this.actualDeliveryDate !== null &&
            this.deliveryNote !== null && this.deliveryNote.trim() !== '' &&
            (files && files.length > 0);
    },
};
